/** How many trailing bet-math attempts the level is computed over. */
export const SCAFFOLD_WINDOW = 10;
/** Below this many attempts we keep FULL help - not enough evidence to fade (§5 first-30-min posture). */
export const SCAFFOLD_MIN_SAMPLES = 3;
/** exact-rate at/above which the aid turns OFF entirely. */
export const SCAFFOLD_OFF_RATE = 0.8;
/** exact-rate at/above which the aid drops to SHORTHAND. */
export const SCAFFOLD_SHORTHAND_RATE = 0.5;
/**
 * The scaffold level from the trailing arithmetic verdicts (newest-last or newest-first - order does
 * not matter, only the exact-rate over the last SCAFFOLD_WINDOW). "exact" counts as accurate; "close"
 * and "off" do not (close means they were near but did not nail it - the aid still helps).
 *
 *   < MIN_SAMPLES attempts        → 'full'      (default to help while we have little evidence)
 *   exact-rate ≥ OFF_RATE         → 'off'
 *   exact-rate ≥ SHORTHAND_RATE   → 'shorthand'
 *   otherwise                     → 'full'
 */
export const scaffoldLevel = (trailing) => {
    const window = trailing.slice(-SCAFFOLD_WINDOW);
    if (window.length < SCAFFOLD_MIN_SAMPLES)
        return 'full';
    const exact = window.filter((v) => v === 'exact').length;
    const rate = exact / window.length;
    if (rate >= SCAFFOLD_OFF_RATE)
        return 'off';
    if (rate >= SCAFFOLD_SHORTHAND_RATE)
        return 'shorthand';
    return 'full';
};
//# sourceMappingURL=scaffold.js.map